import { gql } from "@urql/core";

export const createProductMutStr = `
  mutation createProduct($input: CreateProductStateInput!) {
    createProduct(input: $input) {
      result {
        product {
          id
          orderCode {
            parts {
              options {
                signatures {
                  description
                  value
                  range
                  isDefault
                  state
                  key
                  title
                  presentation
                }
                currentSignature {
                  description
                  value
                  range
                  isDefault
                  state
                  key
                  title
                  presentation
                }
                state
                range {
                  min
                  max
                }
                type
                separator
                key
                title
                presentation
              }
              state
              key
              title
              presentation
            }
            key
            title
            presentation
          }
          selectedAccessories {
            seriesId
            pimId
            seriesName
            currentPresentation
            currentStrategyId
            ordercode {
              parts {
                options {
                  signatures {
                    description
                    value
                    range
                    isDefault
                    state
                    key
                    title
                    presentation
                  }
                  currentSignature {
                    description
                    value
                    range
                    isDefault
                    state
                    key
                    title
                    presentation
                  }
                  state
                  range {
                    min
                    max
                  }
                  type
                  separator
                  key
                  title
                  presentation
                }
                state
                key
                title
                presentation
              }
              key
              title
              presentation
            }
            accessoryId
            accessoryGroupId
            infoText
            optionStates {
              partKey
              optionKey
              signatureKey
              signaturePresentation
              parentRef {
                partKey
                optionKey
              }
              isSizePart
              signatureValue

              separator
            }
            lastChange {
              partKey
              optionKey
              signatureKey
              parentRef {
                partKey
                optionKey
              }
              isSizePart
              signatureValue

              separator
            }
          }
          accessoryGroups {
            id
            name
            accessories {
              seriesId
              pimId
              seriesName
              currentPresentation
              ordercode {
                parts {
                  options {
                    signatures {
                      description
                      value
                      range
                      isDefault
                      state
                      key
                      title
                      presentation
                    }
                    currentSignature {
                      description
                      value
                      range
                      isDefault
                      state
                      key
                      title
                      presentation
                    }
                    state
                    range {
                      min
                      max
                    }
                    type
                    separator
                    key
                    title
                    presentation
                  }
                  state
                  key
                  title
                  presentation
                }
                key
                title
                presentation
              }
              accessoryId
              accessoryGroupId
              infoText
              optionStates {
                partKey
                optionKey
                signatureKey
                signaturePresentation
                parentRef {
                  partKey
                  optionKey
                }
                isSizePart
                signatureValue

                separator
              }
              lastChange {
                partKey
                optionKey
                signatureKey
                parentRef {
                  partKey
                  optionKey
                }
                isSizePart
                signatureValue

                separator
              }
            }
          }
          accessoryInfo {
          accessoryId
          accessoryGroupId
          parent {
              seriesId
              state {
              currentStrategyId
              currentStrategyName
              orderCodeState {
                  optionStates {
                  isSizePart
                  optionKey
                  partKey
                  separator
                  signatureKey
                  signatureValue
                  signaturePresentation
                  parentRef {
                      partKey
                      optionKey
                  }
                  }
                  lastChange {
                  isSizePart
                  optionKey
                  partKey
                  separator
                  signatureKey
                  signatureValue
                  signaturePresentation
                  parentRef {
                      partKey
                      optionKey
                  }
                  }
              }
              propertyStates {
                  id
                  value
              }
              }
          }
        }
          inputs {
            presentation
            properties {
              id
              symbol
              presentation
              description
              displayUnit
              displayValue
              unit
              precision
              value
              valueMin
              valueMax
              valueZeroAllowed
              valueMinInclusive
              valueMaxInclusive
              values
              validationType
              validationMessage
              bomRelevant
            }
          }
          outputs {
            presentation
            properties {
              id
              symbol
              presentation
              description
              displayUnit
              displayValue
              unit
              precision
              value
              valueMin
              valueMax
              valueZeroAllowed
              valueMinInclusive
              valueMaxInclusive
              values
              validationType
              validationMessage
              bomRelevant
            }
          }
          outputsAcoustic {
            presentation
            properties {
              id
              symbol
              presentation
              description
              displayUnit
              displayValue
              unit
              precision
              value
              valueMin
              valueMax
              valueZeroAllowed
              valueMinInclusive
              valueMaxInclusive
              values
              validationType
              validationMessage
              bomRelevant
            }
          }
          availableStrategies {
            id
            presentation
          }
          currentStrategyId
          productType
          pluginName
          serie
          listViewConfiguration {
          columnTitles {
            key
            title
            subTitles {
              key
              title
              subTitles {
                key
                title
                subTitles {
                  key
                  title
                }
              }
            }
          }
            iterableParts {
              partKey
              options{
                optionKey
              }
            }
            targetPropertiesTitle
            targetProperties{
              id
              name
              valueMin
              valueMax
              unit
              defaultValue
              ignorable
            }
                accessories {
                title
                groups {
                  title
                  groupControlType
                  controls {
                    id
                    title
                    boolValue
                    enabledBy
                    enabled
                    keyPresentation
                  }
                }
              }
                attachments {
              title
              groups {
                title
                groupControlType
                controls {
                  id
                  title
                  boolValue
                  enabledBy
                  enabled
                  keyPresentation
                }
              }
            }
          }
        }
        productImageList {
          productImages {
            pimId
            text
            isReportImage
            typ
          }
        }
        specificationText {
          text
        }
      }
      errorCode
      errorMessage
      epfVersion {
        major
        minor
        revision
        build
      }
    }
  }
`;

export const createProductMut = gql`
  ${createProductMutStr}
`;

export const AddProductToNodeMut = gql`
  mutation addProjectNodeConfiguration(
    $nodeId: String!
    $quantity: Int!
    $pimId: String
    $productName: String!
    $orderCode: OrderCodeInput
    $presentation: String!
    $type: String
    $foldedOrderCode: String
    $languageCode: String!
    $price: Float
    $priceGroup: String
    $description: String
  ) {
    addProjectNodeConfiguration(
      nodeId: $nodeId
      price: $price
      priceGroup: $priceGroup
      description: $description
      quantity: $quantity
      pimId: $pimId
      productName: $productName
      orderCode: $orderCode
      presentation: $presentation
      foldedOrderCode: $foldedOrderCode
      type: $type
      languageCode: $languageCode
    ) {
      id
      title
      description
      price
      priceGroup
      type
      foldedOrderCode
      kind
      quantity
      productId
      referencePosition
      nodeId
      localPath
      systemPath
      presentation
      productName
      __typename
    }
  }
`;

export const createProductReport = gql`
  mutation createProductReport($input: SingleProductReportInput!) {
    createProductReport(input: $input) {
      base64Data
    }
  }
`;

export const createProductXBIMReport = gql`
  mutation createProductXBIMReport($input: SingleProductXBIMReportInput!) {
    createProductXBIMReport(input: $input) {
      base64Data
    }
  }
`;

export const createProduct3DModel = gql`
  mutation createProductXBIMReport($input: SingleProductXBIMReportInput!) {
    createProductXBIMReport(input: $input) {
      base64Data
    }
  }
`;

export const createLCAProductReportMut = gql`
  mutation createLCAProductReport($input: CreateLCAProductReportInput!) {
    createLCAProductReport(input: $input) {
      message
      jobId
      status
      url
    }
  }
`;
